import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import {
  INTEGRATION_CATEGORIES,
  IntegrationCategory,
  ThirdPartyIntegration,
  THIRD_PARTY_INTEGRATIONS,
  availabilityLabel,
} from 'src/app/shared/constants/third-party-integrations';

interface IntegrationCard extends ThirdPartyIntegration {
  connectionStatus?: 'connected' | 'disconnected' | 'unknown';
}

@Component({
  selector: 'app-integrations-hub',
  templateUrl: './integrations-hub.component.html',
  styleUrls: ['./integrations-hub.component.css'],
})
export class IntegrationsHubComponent implements OnInit {
  categories = INTEGRATION_CATEGORIES;
  categoryFilter: IntegrationCategory | 'all' = 'all';
  cards: IntegrationCard[] = THIRD_PARTY_INTEGRATIONS.map((i) => ({ ...i }));
  loadingStatus = false;

  availabilityLabel = availabilityLabel;

  constructor(
    private router: Router,
    private api: ApiService
  ) {}

  ngOnInit(): void {
    this.refreshClickUpStatus();
  }

  get filteredCards(): IntegrationCard[] {
    if (this.categoryFilter === 'all') return this.cards;
    return this.cards.filter((c) => c.category === this.categoryFilter);
  }

  setCategory(cat: IntegrationCategory | 'all'): void {
    this.categoryFilter = cat;
  }

  openSetup(card: IntegrationCard): void {
    this.router.navigateByUrl(card.setupRoute);
  }

  categoryLabel(cat: IntegrationCategory): string {
    return INTEGRATION_CATEGORIES.find((c) => c.id === cat)?.label || cat;
  }

  statusBadgeClass(card: IntegrationCard): string {
    if (card.id === 'clickup' && card.connectionStatus === 'connected') return 'badge-connected';
    if (card.availability === 'live') return 'badge-live';
    if (card.availability === 'beta') return 'badge-beta';
    return 'badge-planned';
  }

  statusBadgeText(card: IntegrationCard): string {
    if (card.id === 'clickup') {
      if (card.connectionStatus === 'connected') return 'Connected';
      if (card.connectionStatus === 'disconnected') return 'Not connected';
      return 'Click to configure';
    }
    return availabilityLabel(card.availability);
  }

  private refreshClickUpStatus(): void {
    this.loadingStatus = true;
    this.api.clickupStatus().subscribe({
      next: (res: any) => {
        const connected = !!res?.data?.connected;
        this.cards = this.cards.map((c) =>
          c.id === 'clickup'
            ? { ...c, connectionStatus: connected ? 'connected' : 'disconnected' }
            : c
        );
        this.loadingStatus = false;
      },
      error: () => {
        this.cards = this.cards.map((c) =>
          c.id === 'clickup' ? { ...c, connectionStatus: 'unknown' } : c
        );
        this.loadingStatus = false;
      },
    });
  }
}
